
import Banner from './banner/Banner'
import Header from '../../ui/includes/Header'
import Benefits from './benefits/Benefits'
import Services from './services/Services'
import Pricing from './pricing/Pricing'
import Qutation from './quotation/Quotation'
// import About from './About'
// import Services from './services/Services'
// import Projects from './projects/Projects'
import Faqs from './faqs/Faqs'
import Contact from './contact/Contact'
// import Footer from '../footer/Footer'



const Index = () => {
    return (
        <>
            <Header />
            <Banner />
            {/* <Benefits /> */}
            <Services />
            <Qutation />
            <Pricing />
            {/* <Faqs /> */}
            <Contact />
            {/* <About />
            
            <Projects />
            
            
            <Footer /> */}
        </>
    )
}

export default Index
